<div class="dialog-select-reservation-facilities" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'受付中の予約状況の確定・落選' | translate}}</span>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" style="padding-bottom: 20px;">
    <p><mat-label>■条件</mat-label></p>

    <table style="margin-left: 10px;">
      <tr>
        <td width="150px">{{'予約施設' | translate}}:</td>
        <td width="300px">{{ facility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}</td>
        <td width="150px"></td>
        <td></td>
      </tr>
      <tr>
        <td width="150px">{{'利用日' | translate}}:</td>
        <td width="300px" *ngIf="!reservation.reservation_end_date">{{ reservation.reservation_start_date.seconds * 1000 | date:'yyyy/MM/dd' }}</td>
        <td width="300px" *ngIf="!!reservation.reservation_end_date">{{ reservation.reservation_start_date.seconds * 1000 | date:'yyyy/MM/dd' }} - {{ reservation.reservation_end_date.seconds * 1000 | date:'yyyy/MM/dd' }}</td>
        <ng-container *ngIf="reservation.reservation_times.length > 0">
          <td width="150px">{{'利用時間' | translate}}:</td>
          <td width="300px" >{{ reservation.reservation_times[0].item }}</td>
          <td></td>
        </ng-container>  
      </tr>

      <tr>
        <td width="150px">{{'残予約数' | translate}}:</td>
        <td width="300px" >{{ capacity | number }}</td>
        <td></td>
      </tr>

      <tr *ngIf="facility.reservation_method === 2 && !!lotteryDate">
        <td width="150px">{{'抽選日' | translate}}:</td>
        <td width="300px" >{{ lotteryDate }}</td>
        <td></td>
      </tr>
    </table>

    <div fxLayoutAlign="end stretch" fxLayoutGap="10px" *ngIf="facility.reservation_method === 2" style="margin-top: 20px;">
      <button mat-raised-button color="primary" (click)="lottery()">
        <mat-icon>reduce_capacity</mat-icon>
        <span>{{'抽選' | translate}}</span>
      </button>
    </div>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center" fxFlex="500px" style="overflow: auto;">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let reservation; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
      </ng-container>
  
      <ng-container matColumnDef="edit">
        <th mat-header-cell  *matHeaderCellDef> {{'編集' | translate}} </th>
        <td mat-cell *matCellDef="let reservation">
          <button mat-button color="primary" (click)="openDialog(reservation)">
            <mat-icon>create</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="reservation_no">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約番号' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> {{ reservation.reservation_no }} </td>
      </ng-container>

      <ng-container matColumnDef="company_name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'会社名' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> {{ reservation.company_name }} </td>
      </ng-container>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約者' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> {{ reservation.family_name }}&nbsp;&nbsp;{{ reservation.first_name }} </td>
      </ng-container>
  
      <ng-container matColumnDef="email_address">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メールアドレス' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> {{ reservation.email_address }} </td>
      </ng-container>
  
      <ng-container matColumnDef="reservation_start_date">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'利用日' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> {{ reservation.reservation_start_date.toDate() | date: 'yyyy/MM/dd' }}</td>
      </ng-container>
  
      <ng-container matColumnDef="reservation_end_date">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'利用日(延泊) ' | translate}}</th>
        <td mat-cell *matCellDef="let reservation"><span *ngIf="reservation.reservation_end_date"> {{ reservation.reservation_end_date.toDate() | date: 'yyyy/MM/dd' }} </span></td>
      </ng-container>
  
      <ng-container matColumnDef="reservation_status">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約状況' | translate}} </th>
        <td mat-cell *matCellDef="let reservation"> 
          {{ reservation.reservation_status | reservationStatus }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator class="page" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>

</div>
